import React from 'react';
import {CardTitle} from "reactstrap";
import BadgeWithTooltip from '../FormParts/BadgeWithTooltip'
import PropTypes from 'prop-types';

const propTypes = {
    onclick: PropTypes.func,
};

export default class TitleWithBadge extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            label: this.props.label ? this.props.label : '',
            count: this.props.count !== undefined ? this.props.count: false,
            tmp_set:"off",
        };
    }
    click() {
        return this.props.onclick();
    }
    
    render() {
        // console.log(this.props.badge)
        return (
            <>
                <CardTitle tag="h3" className="float-left">
                {this.state.label}
                {this.props.badge && (
                <BadgeWithTooltip
                    onclick={()=>{this.click();}}
                    class=""
                    id="tmp"
                    icon=""
                    link="#"
                    label={this.props.count}
                    message={"一次保存データが"+this.props.count+"件あります"}
                    size="sm"
                /> )}   
                </CardTitle> 
            </>
        );
    }
}
TitleWithBadge.propTypes = propTypes;